<template>
    <card class="spaced typo">
        
        <h2 class="text-white mb-4">
            {{ $t('xapi.common.activities') }}
        </h2>

        <form @submit.prevent @keydown="filters.errors.clear($event.target.name)">

            <div class="form-row">

                <label class="col-md-1 col-form-label text-md-right text-left pb-0">
                    {{ $t('xapi.common.id') }}
                </label>

                <base-input class="col-md-11"
                    :placeholder="$t('xapi.common.search.iri-placeholder')"
                    v-model="filters.id"
                    name="id"
                    :error="filters.errors.get('id')">
                </base-input>
            </div>

            <div class="form-row">

                <label class="col-md-1 col-form-label text-md-right text-left pb-0">
                    {{ $t('xapi.common.type') }}
                </label>

                <base-input class="col-md-11"
                    :placeholder="$t('xapi.common.search.iri-placeholder')"
                    v-model="filters.type"
                    name="type"
                    :error="filters.errors.get('type')">
                </base-input>
            </div>

            <div class="form-row">

                <label class="col-md-1 col-form-label text-md-right text-left pb-0">
                    {{ $t('xapi.common.name') }}
                </label>

                <base-input class="col-md-11"
                    :placeholder="$t('xapi.common.search.name-placeholder')"
                    v-model="filters.name"
                    name="name"
                    :error="filters.errors.get('name')">
                </base-input>
            </div>

            <div class="text-center pt-1">
                <base-button type="primary" native-type="submit" @click="apply">
                    {{ $t('common.apply') }}
                </base-button>

                <base-button type="primary" native-type="submit" link @click="reset">
                    {{ $t('common.reset') }}
                </base-button>
            </div>

        </form>
    </card>
</template>

<script>
    export default {

        data() {
            return {
                loader: this.$xapi.loaders.activities,
                filters: this.$xapi.filters.activities,
            }
        },

        created() {
            this.$xapi.filters.activities.attach(this)
        },

        methods: {

            apply() {
                this.loader.firstLoad()
            },

            reset() {
                this.filters.reset()
                this.loader.firstLoad()
            }
        }
    }
</script>
